import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import {SaveIntegrationDataProvider} from "../dataProvider/SaveIntegrationDataProvider";

export class SaveIntegrationFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, SaveIntegrationDataProvider);
  }
}
